interface ArrowIconProps extends React.SVGProps<SVGSVGElement> {}
const ArrowIcon = (props: ArrowIconProps) => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Arrow Icon</title>
      <path
        d="M14.4297 5.93018L20.4997 12.0002L14.4297 18.0702"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        d="M3.5 12H20.33"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default ArrowIcon;
